<template>
    <div class="p-3 bg-light">
        <div class="card sa-siat-card-pratica shadow-sm">
            <b-row style="padding-top: 6px">
                <b-col>
                    <b-button v-if="jsonData.statoVisualizzazione !== 'VISUALIZZATA'" size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" :disabled="segnaVisualizzataInCorso" class="mb-2" @click="segnaComeVisualizzata">
                        <i class="fas fa-eye"></i>
                        Segna Come Visualizzata
                    </b-button>
                </b-col>
            </b-row>
            <div class="sa-siat-card-header-custom d-flex align-items-center">
                <b-row class="mt-2 text-muted w-100">
                    <b-col cols="12" style="padding: 8px">
                        <h5 class="m-0 mt-2 text-muted sa-ft-label text-uppercase" style="font-size: 0.9rem">
                            Assistito
                            <strong class="text-primary">{{ jsonData.siatPraticaAssistitoBean ? jsonData.siatPraticaAssistitoBean.numeroAssistito : "Num. Assistito" }}</strong>
                        </h5>
                        <h3 class="m-0 font-weight-bold text-dark mt-1">
                            {{ jsonData.assistito ? jsonData.assistito.toUpperCase() : "COGNOME NAOME" }}
                        </h3>
                    </b-col>
                    <b-col cols="2">
                        <label class="sa-label-data">CODICE FISCALE</label>
                        <span>{{ jsonData.siatPraticaAssistitoBean.codiceFiscale || "CF ASSISTITO" }}</span>
                    </b-col>
                    <b-col cols="1">
                        <label class="sa-label-data">SESSO</label>
                        <span>{{ jsonData.siatPraticaAssistitoBean.sesso || "-" }}</span>
                    </b-col>
                    <b-col cols="1">
                        <label class="sa-label-data">ETA'</label>
                        <span>{{ calcolaEta(jsonData.siatPraticaAssistitoBean.dataNascita) || "-" }}</span>
                    </b-col>
                    <b-col cols="8">
                        <b-row>
                            <b-col cols="6">
                                <label class="sa-label-data">Residenza</label>
                                <span>{{ getResidenza() || "-" }}</span>
                            </b-col>
                            <b-col cols="6">
                                <label class="sa-label-data">Domicilio</label>
                                <span>{{ getDomicilio() || "- " }}</span>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </div>
            <div class="card-body bg-white">
                <b-row class="mb-4">
                    <b-col cols="2" class="form-group">
                        <label class="sa-label-data">CODICE PRATICA</label>
                        <input type="text" class="form-control form-control-sm" v-model="jsonData.codice" readonly />
                    </b-col>
                    <b-col cols="3">
                        <label class="sa-label-data">PROGETTO</label>
                        <input type="text" class="form-control form-control-sm" v-model="jsonData.progetto" readonly />
                    </b-col>
                    <b-col cols="3">
                        <label class="sa-label-data">STATO</label>
                        <select class="form-control form-control-sm" v-model="jsonData.stato">
                            <option value="APERTA">APERTA</option>
                            <option value="CHIUSA">CHIUSA</option>
                        </select>
                    </b-col>
                    <b-col cols="2">
                        <label class="sa-label-data">PRIORITÀ</label>
                        <select class="form-control form-control-sm" v-model="jsonData.priorita">
                            <option value=""></option>
                        </select>
                    </b-col>
                    <b-col></b-col>
                </b-row>
                <!-- <fieldset class="border p-3 rounded mb-4 bg-light-section">
                    <legend class="w-auto px-2 font-weight-bold text-primary small text-uppercase">Sezione di Avvio
                        Pratica</legend>
                    <div class="row">
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">DATA RICHIESTA</label>
                            <input type="date" class="form-control form-control-sm"
                                v-model="dataPratica.avvio.dataRichiesta" />
                        </div>
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">DATA VALUTAZIONE</label>
                            <input type="date" class="form-control form-control-sm"
                                v-model="dataPratica.avvio.dataValitazione" />
                        </div>
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">FIGURA PROFESSIONALE COINVOLTA</label>
                            <select class="form-control form-control-sm"
                                v-model="dataPratica.avvio.figuraProfessionale">
                                <option value=""></option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">DATA AUTORIZZAZIONE ASL</label>
                            <input type="date" class="form-control form-control-sm"
                                v-model="dataPratica.avvio.dataAutorizzazione" />
                        </div>
                    </div>
                </fieldset> -->
                <!-- 
                <fieldset class="border p-3 rounded mb-4 bg-light-section">
                    <legend class="w-auto px-2 font-weight-bold text-primary small text-uppercase">Sezione Conferma
                        Progetto</legend>
                    <div class="row">
                        <div class="col-md-2 form-group">
                            <label class="small font-weight-bold text-muted">DATA APERTURA</label>
                            <input type="date" class="form-control form-control-sm"
                                v-model="dataPratica.conferma.dataApertura" />
                        </div>
                        <div class="col-md-1 form-group">
                            <label class="small font-weight-bold text-muted">DURATA GG</label>
                            <input type="number" class="form-control form-control-sm"
                                v-model="dataPratica.conferma.durataGg" />
                        </div>
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">DATA CHIUSURA</label>
                            <div class="d-flex align-items-center">
                                <input type="date" class="form-control form-control-sm mr-1"
                                    v-model="dataPratica.conferma.dataChiusura" />
                                <input type="time" class="form-control form-control-sm"
                                    v-model="dataPratica.conferma.oraChiusura" />
                            </div>
                        </div>
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">CASUALE CHIUSURA</label>
                            <select class="form-control form-control-sm" v-model="dataPratica.conferma.casualeChiusura">
                                <option value=""></option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">DISTRETTO</label>
                            <select class="form-control form-control-sm" v-model="dataPratica.conferma.distretto">
                                <option value="SORA">FR - DISTRETTO C : SORA</option>
                                <option value="CASSINO">FR - DISTRETTO D : CASSINO</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">CASE MANAGER</label>
                            <input type="text" class="form-control form-control-sm"
                                v-model="dataPratica.conferma.caseManager" placeholder="Cerca..." />
                        </div>
                        <div class="col-md-2 form-group">
                            <label class="small font-weight-bold text-muted">REGIME</label>
                            <select class="form-control form-control-sm" v-model="dataPratica.conferma.regime">
                                <option value="DOMICILIARE">DOMICILIARE</option>
                            </select>
                        </div>
                        <div class="col-md-2 form-group">
                            <label class="small font-weight-bold text-muted">BISOGNO</label>
                            <select class="form-control form-control-sm" v-model="dataPratica.conferma.bisogno">
                                <option value="COMPLESSO">COMPLESSO</option>
                            </select>
                        </div>
                        <div class="col-md-3 form-group">
                            <label class="small font-weight-bold text-muted">LIVELLO ASSISTENZIALE</label>
                            <select class="form-control form-control-sm"
                                v-model="dataPratica.conferma.livelloAssistenziale">
                                <option value=""></option>
                            </select>
                        </div>
                        <div class="col-md-2 form-group">
                            <label class="small font-weight-bold text-muted">LOCAZIONE RESIDENZIALE</label>
                            <select class="form-control form-control-sm"
                                v-model="dataPratica.conferma.locazioneResidenziale">
                                <option value=""></option>
                            </select>
                        </div>
                    </div>
                </fieldset> -->
            </div>
        </div>

        <div class="card shadow-sm border-0 mt-3">
            <div class="card-header bg-primary p-0">
                <ul class="nav nav-tabs custom-siat-tabs border-0">
                    <li class="nav-item" v-for="tab in listaTab" :key="tab.id">
                        <a class="nav-link border-0 text-white font-weight-bold py-3 px-4" :class="{ 'active bg-white text-primary': activeTab === tab.id }" href="#" @click.prevent="activeTab = tab.id">
                            {{ tab.label }}
                        </a>
                    </li>
                </ul>
            </div>

            <div class="card-body bg-white p-3 border">
                <div v-if="activeTab === 'prestazioni_interventi'">
                    <b-row no-gutters>
                        <b-col cols="4">
                            <!-- <div class="w-50"> -->
                            <label>Pai:</label>
                            <b-form-select v-model="paiSelezionato" @change="onChangeEventoPai">
                                <b-form-select-option v-for="(opt, i) of paiOptions" :key="i" :value="opt.pai"> {{ opt.pai }} - {{ opt.stato }} - {{ opt.inizio }} </b-form-select-option>
                            </b-form-select>
                            <!-- </div> -->
                        </b-col>
                        <b-col cols="8">
                            <div v-if="interventiPrestazioniEventoSelezionato.length > 0" style="margin-left: 10px">
                                <b-row v-if="prestazioneSelezionata.frequenza !== null" class="sa-siat-row">
                                    <b-col cols="12" md="4">
                                        <label class="sa-label-data">Frequenza Pianificata</label>
                                        <div class="sa-siat-valore-pai">
                                            <i class="fas fa-history mr-1 text-info"></i>

                                            <template prestazioneSelezionata.frequenzaVolte> {{ prestazioneSelezionata.frequenza.numeroInterventi }}gg {{ prestazioneSelezionata.frequenza.utNumeroInterventi }} per {{ prestazioneSelezionata.frequenza.numeroRipetizioni }} {{ prestazioneSelezionata.frequenza.utNumeroRipetizioni }} </template>
                                            <span>(durata: {{ prestazioneSelezionata.durataPrevista }} min.)</span>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" md="2">
                                        <label class="sa-label-data">Totale Prestazioni:</label>
                                        <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ prestazioneSelezionata.listaEventiPrestazioniIntervallo.length }}</span>
                                    </b-col>
                                    <b-col cols="12" md="3">
                                        <label class="sa-label-data">Figura Professionale</label>
                                        <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ prestazioneSelezionata.figuraProfessionaleDesc }}</span>
                                    </b-col>

                                    <b-col cols="12" md="3">
                                        <label class="sa-label-data">Livello Assistenza P.A.I.</label>
                                        <span class="badge justify-content-center badge-outline-primary border border-primary text-primary px-3" style="font-size: small">{{ prestazioneSelezionata.livelloAssistenzialePai }} </span>
                                    </b-col>
                                </b-row>
                                <b-row v v-else-if="prestazioneSelezionata.frequenzaVolte !== null" class="sa-siat-row">
                                    <b-col cols="12" md="4">
                                        <label class="sa-label-data">Frequenza Pianificata</label>
                                        <div class="sa-siat-valore-pai">
                                            <i class="fas fa-history mr-1 text-info"></i>

                                            <template prestazioneSelezionata.frequenzaVolte> ogni {{ prestazioneSelezionata.frequenzaVolte.numeroGiorni }}gg per {{ prestazioneSelezionata.frequenzaVolte.numeroVolte }} volte </template>
                                            <span>(durata: {{ prestazioneSelezionata.durataPrevista }} min.)</span>
                                        </div>
                                    </b-col>
                                    <b-col cols="12" md="2">
                                        <label class="sa-label-data">Totale Prestazioni:</label>
                                        <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ prestazioneSelezionata.listaEventiPrestazioniIntervallo.length }}</span>
                                    </b-col>
                                    <b-col cols="12" md="3">
                                        <label class="sa-label-data">Figura Professionale</label>
                                        <span class="badge badge-outline-primary border border-primary text-primary px-2">{{ prestazioneSelezionata.figuraProfessionaleDesc }}</span>
                                    </b-col>

                                    <b-col cols="12" md="3">
                                        <label class="sa-label-data">Livello Assistenza P.A.I.</label>
                                        <span class="badge justify-content-center badge-outline-primary border border-primary text-primary px-3" style="font-size: small">{{ prestazioneSelezionata.livelloAssistenzialePai }} </span>
                                    </b-col>
                                </b-row>
                            </div>
                        </b-col>
                        <b-col cols="6">
                            <div>
                                <label class="sa-ft-label">Prestazioni</label>
                                <div class="b-table-sticky-header" style="max-height: 250px !important">
                                    <b-table sticky-header ref="table" stacked="xl" striped :items="prestazioniEventoSelezionato" selectable select-mode="single" :fields="fieldsPrest" :current-page="1" :per-page="perPage" head-variant="light" class="sa-b-table" @row-selected="onRowSelected">
                                        <template #cell(checkbox)="{ rowSelected, selectRow, unselectRow }">
                                            <b-form-checkbox :checked="rowSelected" @change="rowSelected ? unselectRow() : selectRow()"> </b-form-checkbox>
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </b-col>
                        <b-col cols="6">
                            <div>
                                <label class="sa-ft-label">Interventi</label>
                                <div class="b-table-sticky-header" style="max-height: 250px !important">
                                    <b-table sticky-header ref="table" stacked="xl" striped :items="interventiPrestazioniEventoSelezionato" :fields="fields" :current-page="1" :per-page="10000000" head-variant="light" class="sa-b-table">
                                        <template #cell(dataPrevista)="row"> {{ formatDate(row.item.dataPrevista) }} {{ row.item.oraPrevista }} </template>
                                    </b-table>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>

                <div v-else-if="activeTab === 'care_givers'" style="max-height: 200px !important; overflow-y: scroll">
                    <template v-if="jsonData.siatPraticaAssistitoBean.careGivers.length > 0">
                        <div class="card sa-siat-card-pratica shadow-sm" v-for="(cargiver, i) of jsonData.siatPraticaAssistitoBean.careGivers" :key="i">
                            <div class="sa-siat-card-header-custom">
                                <b-row class="mt-2">
                                    <b-col cols="12" style="padding: 8px">
                                        <h5 class="m-0 mt-2 text-muted sa-ft-label text-uppercase" style="font-size: 0.9rem">#{{ i + 1 }} - CareGiver</h5>
                                    </b-col>
                                    <b-col cols="4">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Nominativo</label>
                                            <span class="sa-ft-value"> {{ cargiver.cognome }} {{ cargiver.nome }} </span>
                                        </div>
                                    </b-col>
                                    <b-col cols="4">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Grado Relazione</label>
                                            <span class="sa-ft-value">
                                                {{ cargiver.relazione }}
                                            </span>
                                        </div>
                                    </b-col>
                                    <b-col cols="4">
                                        <div class="sa-ft-data">
                                            <label class="sa-ft-label">Telefono</label>
                                            <span class="sa-ft-value">
                                                {{ cargiver.telefono }}
                                            </span>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </div>
                    </template>
                    <NoDataComponent v-else ref="cmpNoDataComponent" title="Non sono presenti Caregivers per questo assistito" nome="no-data" icon="fas fa-user" />
                </div>
                <div v-else class="text-center py-5 text-muted">
                    <p>
                        Contenuto della sezione <strong>{{ getActiveTabLabel() }}</strong> in fase di caricamento...
                    </p>
                </div>
            </div>
        </div>

        <!-- <div class="d-flex justify-content-between align-items-center mt-4 bg-white p-3 border rounded shadow-sm">
            <button class="btn btn-outline-secondary px-4 shadow-sm" title="Stampa Pratica">
                <i class="fas fa-print"></i> 🖨️ Stampa
            </button>
            <div>
                <button class="btn btn-success font-weight-bold px-4 mr-2 shadow-sm">💾 SALVA</button>
                <button class="btn btn-danger font-weight-bold px-4 shadow-sm" @click="$router.back()">❌
                    ANNULLA</button>
            </div>
        </div> -->
    </div>
</template>

<script>
import axios from "axios";
import NoDataComponent from "../../../template/components/utility/NoDataComponent.vue";
import UtilityMixin from "../../utility/UtilityMixin";
import SiatMixin from "../mixins/SiatMixin";

export default {
    name: "SiatPraticheEditComponent",
    components: {
        NoDataComponent,
    },
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    mixins: [SiatMixin, UtilityMixin],
    data() {
        return {
            activeTab: "prestazioni_interventi",
            segnaVisualizzataInCorso: false,
            paiSelezionato: null,
            id: null,
            pathResource: "/siatpratiche",
            listaTab: [
                { id: "care_givers", label: "Care Givers" },
                { id: "fatturazione", label: "Fatturazione" },
                { id: "pai", label: "Pai" },
                { id: "prestazioni_interventi", label: "Prestazioni e Interventi" },
                { id: "equipe", label: "Equipe assegnata" },
                { id: "terapie", label: "Terapie Riab." },
                { id: "proroghe", label: "Proroghe" },
            ],
            prestazioniEventoSelezionato: [],
            prestazioneSelezionata: {},
            interventiPrestazioniEventoSelezionato: [],
            comuniOptions: [],
            paiOptions: [],

            items: [],
            currentPage: 1,
            perPage: 50,
            fields: [
                { key: "esito", label: "E" }, // Sostituisci 'esito' con la tua proprietà dati
                { key: "numeroIntervento", label: "Codice" },
                {
                    key: "dataPrevista",
                    label: "Data Prevista",
                },
                {
                    key: "dataEffettivaEsecuzione",
                    label: "Data Esecuzione",
                    formatter: (v) => {
                        return this.formatDate(v);
                    },
                },
                {
                    key: "operatoreNome",
                    label: "Operatore",
                    formatter: (v) => {
                        return v ? v : "Non Specificato";
                    },
                },
                { key: "statoIntervento", label: "Stato" },
            ],
            fieldsPrest: [
                {
                    label: "",
                    key: "checkbox",
                    thStyle: "width: 2rem",
                },
                { label: "Codice", key: "numeroPrestazione", thStyle: "width: 2rem" },
                {
                    label: "Inizio",
                    key: "dataInizioInterventi",
                    formatter: (v) => {
                        return this.formatDate(v);
                    },
                    thStyle: "width: 8rem",
                },
                {
                    label: "Fine",
                    key: "fine",
                    formatter: () => {
                        return "-";
                    },
                    thStyle: "width: 8rem",
                },
                { label: "Prestazione", key: "tipoPrestazioneDescrizione" },
            ],

            jsonData: {
                siatPraticaAssistitoBean: {
                    careGivers: [],
                },
                listaPraticaEventoBeans: [],
            },
        };
    },
    mounted() {
        this.id = this.$route.params.id;
        //this.loadComuni();
        this.loadData();
    },
    watch: {},
    computed: {},
    methods: {
        loadData() {
            this.openShowModalLoading();
            this.loadDataResources(this.pathResource + "/" + this.id, {}, this.loadDataSuccess, this.loadDataError);
        },
        loadDataSuccess(response) {
            this.jsonData = response.data.data;
            if (this.jsonData.listaPraticaEventoBeans.length > 0) {
                this.setPai();
            }
            this.paiSelezionato = this.paiOptions[0].pai;
            this.onChangeEventoPai(this.paiOptions[0].pai);
            this.closeShowModalLoading();
        },
        loadDataError(error) {
            error;
            this.closeShowModalLoading();
        },
        setPai() {
            this.paiOptions = [];
            this.jsonData.listaPraticaEventoBeans.forEach((element) => {
                if (element.prestazioni && Array.isArray(element.prestazioni) && element.prestazioni.length > 0) {
                    element.prestazioni.forEach((prestazione) => {
                        if (prestazione.poId) {
                            const giaPresente = this.paiOptions.some((opzione) => opzione.pai === prestazione.poId);
                            if (!giaPresente) {
                                let pai = {
                                    pai: prestazione.poId,
                                    stato: prestazione.operativitaServizio,
                                    inizio: prestazione.dataInizioInterventi,
                                };
                                this.paiOptions.push(pai);
                            }
                        }
                    });
                }
            });
        },
        segnaComeVisualizzata() {
            if (this.segnaVisualizzataInCorso) {
                return;
            }
            this.segnaVisualizzataInCorso = true;
            let link = process.env.VUE_APP_PATH_API + this.pathResource + "/visualizza/" + this.id;
            axios
                .put(link)
                .then((response) => {
                    if (response.data && response.data.data) {
                        this.jsonData.statoVisualizzazione = response.data.data.statoVisualizzazione;
                    } else {
                        this.jsonData.statoVisualizzazione = "VISUALIZZATA";
                    }
                    this.segnaVisualizzataInCorso = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.segnaVisualizzataInCorso = false;
                });
        },
        loadComuni() {
            let me = this;
            let link = process.env.VUE_APP_PATH_API + "/comuni";
            axios
                .get(link)
                .then((response) => {
                    me.comuniOptions = response.data.data;
                    this.closeShowModalLoading();
                })
                .catch(() => {
                    this.closeShowModalLoading();
                });
        },
        init(jsonData) {
            this.jsonData = jsonData;
        },
        onRowSelected(items) {
            this.prestazioneSelezionata = items[0];

            this.interventiPrestazioniEventoSelezionato = [];
            if (items[0]) {
                let item = items[0];
                if (item.listaEventiPrestazioniIntervallo) {
                    this.interventiPrestazioniEventoSelezionato = item.listaEventiPrestazioniIntervallo;
                }
            }
        },
        getActiveTabLabel() {
            let tab = this.listaTab.find((t) => t.id === this.activeTab);
            return tab ? tab.label : "";
        },
        getClassBadge(item) {
            switch (item.statoSiat) {
                case "Aperta":
                    return "sa-ft-badge success";
                case "Chiusa":
                    return "sa-ft-badge danger";
                default:
                    break;
            }
        },
        calcolaEta(dataNascitaStringa) {
            const oggi = new Date();
            const dataNascita = new Date(dataNascitaStringa);
            let eta = oggi.getFullYear() - dataNascita.getFullYear();
            const meseDiff = oggi.getMonth() - dataNascita.getMonth();
            const giornoDiff = oggi.getDate() - dataNascita.getDate();
            if (meseDiff < 0 || (meseDiff === 0 && giornoDiff < 0)) {
                eta--;
            }

            return eta;
        },
        getFormatoEuro(value) {
            return value.toLocaleString("it-IT", {
                style: "currency",
                currency: "EUR",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        },
        onChangeEventoPai(evento) {
            this.prestazioniEventoSelezionato = [];
            this.jsonData.listaPraticaEventoBeans.forEach((element) => {
                let prestazioniCollegate = element.prestazioni.filter((e) => e.poId == evento);
                this.prestazioniEventoSelezionato.push(...prestazioniCollegate);
            });
        },
        getDomicilio() {
            // return "";
            let assistito = this.jsonData.siatPraticaAssistitoBean;
            if (!assistito) return "";
            let parti = [];
            if (assistito.indirizzoDomicilio) {
                parti.push(assistito.indirizzoDomicilio.trim());
            }
            if (assistito.civicoDomicilio) {
                parti.push(assistito.civicoDomicilio.trim());
            }
            if (assistito.capDomicilio) {
                parti.push(assistito.capDomicilio.trim());
            }
            if (assistito.comuneDomicilio) {
                // let comune = { comune: "" };
                // console.log(this.comuniOptions.find((e) => e.codiceIstat == assistito.comuneResidenza));

                parti.push(assistito.comuneDomicilioDescrizione.trim());
            }

            return parti.join(", ");
        },
        getResidenza() {
            // return "";
            let assistito = this.jsonData.siatPraticaAssistitoBean;
            if (!assistito) return "";
            let parti = [];
            if (assistito.indirizzoResidenza) {
                parti.push(assistito.indirizzoResidenza.trim());
            }
            if (assistito.civicoResidenza) {
                parti.push(assistito.civicoResidenza.trim());
            }
            if (assistito.capResidenza) {
                parti.push(assistito.capResidenza.trim());
            }
            if (assistito.comuneResidenza) {
                // let comune = { comune: "" };
                // console.log(this.comuniOptions.find((e) => e.codiceIstat == assistito.comuneResidenza));

                parti.push(assistito.comuneResidenzaDescrizione.trim());
            }

            return parti.join(", ");
        },
        pulisciData(d) {
            //return d ? d.split("+")[0] : "-";
            return this.formatDate(d);
        },
    },
};
</script>

<style scoped>
.bg-light-section {
    background-color: #fcfdfe;
}

.custom-siat-tabs .nav-link {
    border-radius: 4px 4px 0 0;
    margin-right: 2px;
    opacity: 0.85;
}

.custom-siat-tabs .nav-link.active {
    opacity: 1;
    border-bottom: 2px solid transparent !important;
}

.tracking-wider {
    letter-spacing: 0.05em;
}

.sa-siat-card-pratica {
    border: none;
    border-radius: 12px;
    margin-bottom: 25px;
    overflow: hidden;
}

.sa-siat-card-header-custom {
    background: #fff;
    border-bottom: 1px solid #edf2f7;
    padding: 15px 20px;
}

.sa-siat-text-indirizzo {
    font-size: 1rem;
}
</style>
